/* eslint-disable */
import { useDataContext } from '../context';
import React, { useEffect, useRef } from 'react'; // 1. เพิ่ม useRef เข้ามา

// ประกาศตัวแปรรับค่าจาก env
const API_URL = import.meta.env.VITE_API_URL;

function AllDepartment() {
  const { data, setData } = useDataContext();
  
  // 2. สร้างตัวแปรกันยิงซ้ำ (Protection Flag)
  const hasFetched = useRef(false);

  useEffect(() => {
    // -----------------------------------------------------------
    // ✅ จุดแก้ที่ 1: เช็คว่ามีข้อมูล allBranch ใน Context หรือยัง?
    // ถ้ามีแล้ว ให้ return ออกไปเลย
    // -----------------------------------------------------------
    if (data?.allBranch && data.allBranch.length > 0) {
      // console.log("Branch data already exists. Skipping fetch.");
      return;
    }

    // -----------------------------------------------------------
    // ✅ จุดแก้ที่ 2: เช็คว่า Component นี้เคยสั่งยิงไปแล้วหรือยัง?
    // -----------------------------------------------------------
    if (hasFetched.current) return;

    const fetchData = async () => {
      // Mark ว่ากำลังยิงแล้วนะ ห้ามยิงซ้ำ
      hasFetched.current = true;

      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      try {
        // ✅ ใช้ API_URL แทน Hardcode URL
        const response = await fetch(`${API_URL}/getAllBranches`, requestOptions);
        const result = await response.json();
        
        // อัปเดตข้อมูลเข้า Context
        setData(prevData => ({
            ...prevData, 
            allBranch: result.data // map เข้าตัวแปร allBranch ตามโค้ดเดิม
        }));
      } catch (error) {
        console.error("Error fetching branches:", error);
        hasFetched.current = false; // ถ้า Error ให้ reset เผื่อจะ retry ได้
      }
    };

    fetchData();

    // -----------------------------------------------------------
    // ✅ จุดแก้ที่ 3: Dependency Array ต้องว่าง [] 
    // -----------------------------------------------------------
  }, []); 

  return null;
}

export default AllDepartment;
